
































































































import currencyFilter from "@/filters/currency.filter";
import dateFormat from "@/filters/date.filter";
import { debounceProcess } from "@/helpers/debounce";
import { useBlob, useDate } from "@/hooks";
import {
  DATE_TIME_DEFAULT_FORMAT,
  DEFAULT_DATE_FORMAT,
} from "@/models/constants/date.constant";
import { DataResponseJournalTransaction } from "@/models/interface/accounting.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { accountingService } from "@/services/accounting.service";
import { settingsServices } from "@/services/settings.service";
import { SorterProps } from "@/types";
import { WrappedFormUtils } from "ant-design-vue/types/form/form";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class JournalTransactions extends Vue {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  form!: WrappedFormUtils;
  sortBy = "";
  dataSource: DataResponseJournalTransaction[] = [];
  loading = {
    accountNumber: false,
    find: false,
    download: false,
  };
  dataAccountNumber: any[] = [];
  columnsTable = [
    {
      title: this.$t("lbl_journal_date"),
      dataIndex: "journalDate",
      key: "journalDate",
      width: 150,
      sorter: true,
      customRender: (text: string) => dateFormat(text),
    },
    {
      title: this.$t("lbl_journal_number"),
      dataIndex: "journalNumber",
      key: "journalNumber",
      width: 150,
    },
    {
      title: this.$t("lbl_account_number"),
      dataIndex: "accountNumber",
      key: "accountNumber",
      width: 150,
    },
    {
      title: this.$t("lbl_account_name"),
      dataIndex: "accountName",
      key: "accountName",
      width: 150,
    },
    {
      title: this.$t("lbl_line_description"),
      dataIndex: "lineDescription",
      key: "lineDescription",
      customRender: (text: string) => text || "-",
    },
    {
      title: this.$t("lbl_description"),
      dataIndex: "description",
      key: "description",
      customRender: (text: string) => text || "-",
    },
    {
      title: this.$t("lbl_journal_reference"),
      dataIndex: "journalReference",
      key: "journalReference",
    },
    {
      title: this.$t("lbl_debit"),
      dataIndex: "debit",
      key: "debet",
      align: "right",
      customRender: (text: number) => currencyFilter(text),
    },
    {
      title: this.$t("lbl_credit"),
      dataIndex: "credit",
      key: "credit",
      align: "right",
      customRender: (text: number) => currencyFilter(text),
    },
    {
      title: this.$t("lbl_balance"),
      dataIndex: "balance",
      key: "balance",
      align: "right",
      customRender: (text: number) => currencyFilter(text),
    },
  ];
  formRules = {
    accountNumber: {
      label: "lbl_account_number",
      name: "lbl_account_number",
      placeholder: "lbl_account_number_placeholder",
      decorator: ["accountNumber"],
    },
    periodFrom: {
      label: "lbl_period_from",
      name: "lbl_period_from",
      placeholder: "lbl_period_from_placeholder",
      decorator: ["periodFrom"],
    },
    periodTo: {
      label: "lbl_period_to",
      name: "lbl_period_to",
      placeholder: "lbl_period_to_placeholder",
      decorator: ["periodTo"],
    },
  };

  beforeCreate(): void {
    this.form = this.$form.createForm(this, { name: "journalTransactions" });
  }

  created(): void {
    this.searchData = debounceProcess(this.searchData, 500);
  }

  mounted() {
    this.getAccountNumber("");
  }

  searchData(value) {
    this.getAccountNumber(value);
  }

  getAccountNumber(value) {
    const params: RequestQueryParamsModel = {
      page: 0,
      limit: 10,
      sorts: "code:asc",
    };
    if (value) params.search = `code~*${value}*_OR_description~*${value}*`;

    settingsServices.listOfCoa(params, "").then(res => {
      res.data.forEach(element => {
        element["label"] = `${element.code} - ${element.description}`;
      });
      this.dataAccountNumber = res.data;
    });
  }

  getListReport(params: RequestQueryParamsModel) {
    this.loading.find = true;
    accountingService
      .getJournalTransaction(params)
      .then(res => {
        this.dataSource = res;
      })
      .finally(() => {
        this.loading.find = false;
      });
  }

  downloadReport(params: RequestQueryParamsModel) {
    const { toDownload } = useBlob();
    this.loading.download = true;
    accountingService
      .getJournalTransactionDownload(params)
      .then(res => {
        toDownload(res, "general_ledger.xlsx");
      })
      .finally(() => (this.loading.download = false));
  }

  buildDownloadParams(formValue: Record<string, any>): string {
    const company =
      this.$store.state.authStore.authData.companyName ||
      "PT. SATRIA PIRANTI PERKASA";

    let account = "ALL";
    if (formValue.accountNumber) {
      account = formValue.accountNumber.label;
    }

    const startPeriod = formValue.periodFrom
      ? moment(formValue.periodFrom).format(DEFAULT_DATE_FORMAT)
      : "ALL";

    const endPeriod = formValue.periodTo
      ? moment(formValue.periodTo).format(DEFAULT_DATE_FORMAT)
      : "ALL";

    return `${company},${account},${startPeriod},${endPeriod}`;
  }

  onclickButton(type: "reset" | "find" | "download", triger) {
    const { toStartDay, toEndDay } = useDate();
    const value = this.form.getFieldsValue();
    const params: RequestQueryParamsModel = {
      sorts: this.sortBy,
    };

    if (value.accountNumber) {
      params.accountId = value.accountNumber.key;
    }

    if (value.periodFrom) {
      params.dateFrom = toStartDay(value.periodFrom).format(
        DATE_TIME_DEFAULT_FORMAT
      );
    }

    if (value.periodTo) {
      params.dateTo = toEndDay(value.periodTo).format(DATE_TIME_DEFAULT_FORMAT);
    }

    switch (type) {
      case "find": {
        this.getListReport(params);
        break;
      }
      case "download": {
        params.params = this.buildDownloadParams(value);
        this.downloadReport(params);
        break;
      }
      case "reset": {
        this.form.resetFields();
        break;
      }
    }
  }

  get formItemLayout() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 8 },
    };
  }

  onTableChange(_, __, sort: SorterProps): void {
    const { columnKey, order } = sort;
    this.sortBy = "";
    if (order === "ascend") {
      this.sortBy = `${columnKey}:asc`;
    } else if (order === "descend") {
      this.sortBy = `${columnKey}:desc`;
    }
    this.onclickButton("find", "Yes");
  }
}
